import React from 'react';
import {
  Image,
  StyleSheet,
  Text,
  TouchableHighlight,
  View,
} from './base_components';
import LinkImageButton from './buttons/link_image_button';
import ImageButton from './buttons/image_button';
import RightMenu from './right_menu';

import { useUser, useOrg } from '../stores/user_store';

const styles = StyleSheet.create({
  header: {
    alignSelf: 'stretch',
    height: '4rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#333',
  },
  spacer: {
    flex: 1,
  },
  logo: {
    marginLeft: '1rem',
    width: '10rem',
    height: '2.8rem',
    marginRight: '1rem',
    filter: 'var(--icon-header-grey)',
  },
  orgText: {
    marginLeft: '3rem',
    marginRight: '0.5rem',
    color: '#f1f1f1',
    fontSize: '1.3rem',
    fontWeight: '600',
  },
  menu: {
    marginLeft: '1rem',
    height: '2rem',
    width: '2rem',
    padding: '0.75rem',
    filter: 'var(--icon-white)',
  },
  userMenu: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  userText: {
    marginRight: '0.5rem',
    color: 'white',
    fontSize: '1.35rem',
    fontWeight: '500',
  },
  image: {
    width: '1rem',
    height: '1rem',
    filter: 'var(--icon-white)',
    transform: 'rotate(90deg)',
  },
  imageOpen: {
    transform: 'rotate(270deg)',
  },
});

const LOGO = require('../assets/img/logo.png');
const MENU = require('../assets/img/menu_black.png');
const ARROW = require('../assets/img/arrow_right_black.png');

export default function Header(props) {
  const { style } = props;
  const user = useUser();
  const org = useOrg();
  const [show_menu, setShowMenu] = React.useState(false);
  function _onUserPress() {
    setShowMenu(!show_menu);
  }
  function _onMenuClose() {
    setShowMenu(false);
  }
  return (
    <>
      <View style={[styles.header, style]}>
        <ImageButton style={styles.menu} source={MENU} onPress={props.onMenu} />
        <LinkImageButton
          style={styles.logo}
          source={LOGO}
          resizeMode='contain'
          url='/'
        />
        <Text style={styles.orgText}>Org: {org?.org_name}</Text>
        <View style={styles.spacer} />
        <TouchableHighlight
          style={styles.userMenu}
          underlayColor='rgba(255,255,255,0.1)'
          onPress={_onUserPress}
        >
          <Text style={styles.userText}>{user?.user_name ?? user?.email}</Text>
          <Image
            style={[styles.image, show_menu ? styles.imageOpen : null]}
            source={ARROW}
          />
        </TouchableHighlight>
      </View>
      {show_menu ? <RightMenu onClose={_onMenuClose} /> : null}
    </>
  );
}
